import { clients } from 'lib/https';
import { SidebarItem } from 'components/blocks/layout/types/sidebar-conversation';
import { ConfigurationSettings } from '../../models/configuration-settings';
import { ApiConversationResponse, updateProject } from 'features/projects/services/projects-services';
import { useConfig } from 'hooks/use-config';
import { useGlobalMutation } from 'state/query-client/hooks';
import { useToast } from 'hooks/use-toast';
import { useTranslation } from 'react-i18next';

export interface ChatApiResponse {
  results: SidebarItem[];
  total_count: number;
  message: string;
  status: string;
}

export interface ArchiveApiResponse {
  modified_count: number;
  message: string;
  status: string;
}

export interface ArchivedChatsParams {
  pageSize?: number;
  page?: number;
}

export const getArchivedChats = async (
  param: ArchivedChatsParams,
  config: ConfigurationSettings
): Promise<ChatApiResponse> => {

      const payload = {
        "page": (param.page ??  0) + 1,
        "pageSize": param.pageSize,
        "isArchived": true
        }
  
        const baseUrl = `https://${config.paths.taskforceBaseUrl}`;
        const url = `${baseUrl}${config.paths.taskforce.collaborationConversation}`;
        const res = await clients.post<{ data: ApiConversationResponse[], total_count: number }>(
          `${url}`,
          config.blocksKey,
          JSON.stringify(payload)
        );

        const items = (res.data || []).map(
          (conversation: ApiConversationResponse) => ({
            ProjectId: conversation.projectId || '',
            ConversationId: conversation.conversationId,
            ConversationTitle: conversation.conversationTitle,
            CreatedBy: conversation.createdBy,
            TenantId: conversation.tenantId,
            CreatedDate: conversation.createdAt,
            LastUpdatedDate: conversation.lastUpdatedAt,
            Conversations: conversation.messages,
          })
        );
  
        return {
          results: items,
          total_count: res.total_count,
          message: 'success',
          status: 'success',
        };

};

export const unArchiveChat = async (
  conversationId: string,
  config: ConfigurationSettings
): Promise<ArchiveApiResponse> => {
  const baseUrl = `https://${config.paths.baseUrl}`;
  return clients.post(
    `${baseUrl}${config.paths.taskforce.unarchive}`,
    config.blocksKey,
    JSON.stringify({
      conversation_id: conversationId,
    })
  );
};

export const useHandleArchiveUnarchive = () => {
    const { configurationSettings } = useConfig();
    const { toast } = useToast();
    const { t } = useTranslation();

    interface UpdateProjectPayload {
        isArchived?: boolean;
        conversationId: string;
    }

    return useGlobalMutation({
        mutationKey: ['handleArchiveUnarchive'],
        mutationFn: (payload: UpdateProjectPayload) =>
            updateProject(configurationSettings, payload),
        onSuccess: () => {
           toast({
                        variant: "success",
                        title: "Success",
                        description: t('CONVERSATION_UNARCHIVE_SUCCESSFULLY')
                    });
        },
        onError: (error) => {
            console.error('Failed to update project:', error);
        },
    });
};
